import { Nullable } from 'utils/types';

export enum FIELDS {
  MINIMUM_RETIRED_INCOME = 'minimumRetiredIncome',
  FUTURE_INCOME_TOTAL = 'futureIncomeTotalIncome',
  EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME = 'employedAnticipatedGrossAnnualIncome',
  EMPLOYED_ANTICIPATED_RETIREMENT_DATE = 'employedIncomeDetails',
  SELF_EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME = 'selfEmployedAnticipatedGrossAnnualIncome',
  SELF_EMPLOYED_ANTICIPATED_RETIREMENT_DATE = 'selfEmployedIncomeDetails',
  MINIMUM_TAXABLE_RETIRED_INCOME = 'minimumTaxableRetiredIncome',
  HAS_TAXABLE_RETIRED_INCOME_CONTINUING = 'hasTaxableRetiredIncomeContinuing',
  MINIMUM_TAX_FREE_RETIRED_INCOME = 'minimumTaxFreeRetiredIncome',
  HAS_TAX_FREE_RETIRED_INCOME_CONTINUING = 'hasTaxFreeRetiredIncomeContinuing',
  OTHER_INCOME_ANTICIPATED_GROSS_ANNUAL_INCOME = 'otherIncomeAnticipatedGrossAnnualIncome',
  OTHER_INCOME_DETAILS = 'otherIncomeDetails',
  FUTURE_INCOME_PENSION = 'futureIncomePensionIncome',
  MINIMUM_TAXABLE_RETIRED_INCOME_DETAILS = 'minimumTaxableRetiredIncomeDetails',
  MINIMUM_TAX_FREE_RETIRED_INCOME_DETAILS = 'minimumTaxFreeRetiredIncomeDetails',
}

export type Future = {
  [FIELDS.MINIMUM_RETIRED_INCOME]: Nullable<number>;
  [FIELDS.FUTURE_INCOME_TOTAL]: Nullable<number>;
  [FIELDS.EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME]: Nullable<number>;
  [FIELDS.EMPLOYED_ANTICIPATED_RETIREMENT_DATE]: Nullable<string>;
  [FIELDS.SELF_EMPLOYED_ANTICIPATED_GROSS_ANNUAL_INCOME]: Nullable<number>;
  [FIELDS.SELF_EMPLOYED_ANTICIPATED_RETIREMENT_DATE]: Nullable<string>;
  [FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME]: Nullable<number>;
  [FIELDS.HAS_TAXABLE_RETIRED_INCOME_CONTINUING]: Nullable<boolean>;
  [FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME]: Nullable<number>;
  [FIELDS.HAS_TAX_FREE_RETIRED_INCOME_CONTINUING]: Nullable<boolean>;
  [FIELDS.OTHER_INCOME_ANTICIPATED_GROSS_ANNUAL_INCOME]: Nullable<number>;
  [FIELDS.OTHER_INCOME_DETAILS]: Nullable<string>;
  [FIELDS.MINIMUM_TAXABLE_RETIRED_INCOME_DETAILS]: Nullable<string>;
  [FIELDS.MINIMUM_TAX_FREE_RETIRED_INCOME_DETAILS]: Nullable<string>;
  [FIELDS.FUTURE_INCOME_PENSION]: Nullable<number>;
};
